import styled from '@emotion/styled'
import { metrics } from '../../../__styling/settings/metrics'
import { breakWords } from '../../../__styling/style-mixins'
import { themedValue } from '../../../__styling/themed-value'

export const StyledContent = styled('div')(({ theme }) => ({
    marginBottom: themedValue(theme, {
        fallback: metrics.perthnow.margins.md,
        perthnow: metrics.thewest.margins.md,
    }),
    ...breakWords,
}))
